import { Component, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { ActivatedRoute, Router } from "@angular/router";
import { name } from "@azure/msal-browser/dist/packageMetadata";
import { NgxSpinnerService } from "ngx-spinner";
import { single, interval, Subscription, take } from "rxjs";
import {
  Entities,
  ErrorCodes,
  NodeTypes,
} from "../../../../core/models/globals";
import {
  Session,
  SessionInfo,
  PerDaySession,
  ClientSession,
} from "../../../../core/models/session";
import { UserRoleNames } from "../../../../core/models/users";
import { Users } from "../../../../core/models/users";
import { UserSetting } from "../../../../core/models/userSetting";
import { ActionLogService } from "../../../../core/services/action-log.service";
import { AuthenticationService } from "../../../../core/services/authentication.service";
import { HeaderService } from "../../../../core/services/header.service";
import { NavigationService } from "../../../../core/services/navigation.service";
import { NodeService } from "../../../../core/services/node.service";
import { SessionService } from "../../../../core/services/session.service";
import { SyncConfigService } from "../../../../core/services/sync-config.service";
import { UserService } from "../../../../core/services/user.service";
import { DynamicWorkstationComponent } from "../../../node/modals/dynamic-workstation/dynamic-workstation.component";
import { EditColoumsComponent } from "../../../node/modals/edit-coloums/edit-coloums.component";
import { ConfirmDialogComponent } from "../../../shared/components/confirm-dialog/confirm-dialog.component";

@Component({
  selector: "app-client-session",
  templateUrl: "./client-session.component.html",
  styleUrls: ["./client-session.component.scss"],
})
export class ClientSessionComponent implements OnInit {
  available: boolean;
  sessions: Session[];
  filterText: string = "";
  currentEntity;
  columnsLocalStorageNames: string[] = [
    "allNodeListColoumnsInfo",
    "nodeListColoumnsInfo",
    "userListColumnsInfo",
  ];
  newDate: Date = new Date();
  timePeriod: Number[] = [1, 2, 4, 6, 8, 10];
  tempSessionName;
  p: number = 1;
  filterSessionState: string = "All"; // filter
  filterUser: string = "All"; // filter
  filterVms: string = "All"; // filter
  filterOs: string = "All";
  filterDeployment: string = "All";
  avlSessionStatesForFilter: string[] = [];
  avlUserForFilter: string[] = [];
  avlVMsForFilter: string[] = [];
  dataReloadSubscription: Subscription;
  filteredSessions: Session[] = [];
  useVncFile: boolean = false;
  currentLoggedInUser = this.authenticationService.currentUserValue.username;
  columnInfo: {
    columnsOfComponents: string[];
    coloumToShow: string[];
  };
  x: boolean = true;
  columnList: string[] = ["First Name", "Last Name"];
  editedColumnList: string[] = [];
  serialNoSort: boolean = false;
  loginTimeSort: boolean = false;
  idleTimeSort: boolean = false;
  durationSort: boolean = false;
  userSort: boolean = false;
  nameSessionSort: boolean = false;
  sortApplied: boolean = false;
  sortBy: string = null;
  sessionTooltipHtml: string = "";
  depList: string[] = [];
  tableName: string = "sessionList";
  redirectSortVal: string | null;
  isMonitor: boolean =
    this.authenticationService.currentUserValue.role == UserRoleNames.Reader
      ? true
      : false;
  users: Users;
  clientSessions: ClientSession[] = [];

  constructor(
    private route: ActivatedRoute,
    private navService: NavigationService,
    private sessionService: SessionService,
    private headerService: HeaderService,
    private actionLogService: ActionLogService,
    public syncConfig: SyncConfigService,
    public dialog: MatDialog,
    public snackBar: MatSnackBar,
    private spinner: NgxSpinnerService,
    public nodeService: NodeService,
    private authenticationService: AuthenticationService,
    private userService: UserService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.columnInfo = {
      columnsOfComponents: [],
      coloumToShow: [
        "Session State",
        "User",
        "UserName",
        "Login Time",
        "Idle Time",
        "Expiration Time",
        "Session Apps",
      ],
    };
    this.columnInfo.columnsOfComponents = [
      "Login Time",
      "Idle Time",
      "Expiration Time",
      "Deployment",
      "Duration",
      "Session Apps",
      "CPU %",
      "RAM %",
      "GPU %",
    ];
    this.loadUserDetails();
    this.navService.breadcrumbEntity.subscribe((x) => {
      this.currentEntity = x;
    });
    this.navService.sendParentData(Entities.Sessions);
    this.navService.sendLeftPanelIndex(0);
    this.loadSessionData();
    this.startDataReloadSub();
    // this.createLocalStorage();
    this.getColumnSetting();
    this.checkDashboardRedirectSort();
  }

  ngOnDestroy() {
    this.sessionService.dashboardSessionRedirectSort = null;
    this.dataReloadSubscription?.unsubscribe();
  }

  loadTimePeriod() {
    for (let i = 1; i < 25; i++) {
      this.timePeriod.push(i);
    }
  }

  getAllSessionsForUser;

  loadSessionData() {
    this.loadClientSessionData();
    this.sessionService
      //.getAllSessions().subscribe({
      .getClientSessionsForUser(this.currentLoggedInUser)
      .subscribe({
        next: (data) => {
          this.spinner.hide();
          if (data == null) {
            this.available = false;
            return;
          }
          this.sessions = <Session[]>JSON.parse(JSON.stringify(data));
          this.available = true;
        },
        error: (err) => {
          this.spinner.hide();
          this.available = false;
        },
      });
    this.available = true;
  }

  connectVdiNode() {
    const dialogRef = this.dialog.open(DynamicWorkstationComponent, {
      width: "25vw",
      autoFocus: false,
      disableClose: true,
      data: {
        deploymentNames: this.headerService.getQuickAccessDeploymentNames(),
        gpuNames: [null],
        availableRam: [null],
        availableCores: [null],
        perSessionMaxTime: this.users.perSessionMaxTime,
      },
    });
    dialogRef.afterClosed().subscribe((res) => {
      if (res) {
        setTimeout((x) => {
          this.loadSessionData();
          this.refreshComponent();
        }, 1000);
      }
    });
  }

  removeSession(session: Session) {
    let message = `Do you want to remove ${session.user} from ${session.vmName}?`;
    if (session.vmName == null || session.vmName == "") {
      message = `Do you want to remove ${session.user} session?`;
    }
    this.dialog
      .open(ConfirmDialogComponent, {
        autoFocus: false,
        disableClose: false,
        width: "25%",
        data: {
          titleMessage: "Remove Session",
          bodyMessage: message,
          cancelText: "Cancel",
          submitText: "Proceed",
        },
      })
      .afterClosed()
      .subscribe((res) => {
        if (res) {
          this.snackBar.open("Action is in progress.", "Ok", {
            duration: 5000,
          });
          setTimeout((x) => {
            this.refreshComponent();
          }, 2000);
          let sessionVm = session.vmName;
          if (session.vmName == "" || session.vmName == null) {
            sessionVm = "NA";
          }
          this.sessionService
            .removeSession(
              sessionVm.toLowerCase(),
              session.user.toLowerCase(),
              session.deployment.toLowerCase(),
              this.currentLoggedInUser.toLowerCase()
            )
            .subscribe({
              next: (data: any) => {
                if (data.status == 200) {
                  this.snackBar.open(data.actionMessage, "Ok", {
                    duration: 5000,
                  });
                }
                this.refreshComponent();
                this.loadSessionData();
              },
              error: (err) => {
                if (err?.error?.status == 401 || err?.error?.status == 404) {
                  this.snackBar.open("Action can not be performed.", "Ok", {
                    duration: 5000,
                  });
                  this.refreshComponent();
                }
              },
            });
        }
      });
  }
  loadUserDetails() {
    this.userService
      .getUserDetails(this.currentLoggedInUser)
      .subscribe((data) => {
        this.users = <Users>JSON.parse(JSON.stringify(data));
      });
  }
  applyFilter() {
    //this.dataReloadSubscription?.unsubscribe();
    this.filteredSessions = this.sessions;
    if (this.filterDeployment != "All") {
      this.filteredSessions = this.filteredSessions?.filter(
        (nd) => nd.deployment == this.filterDeployment
      );
    }
    if (this.filterOs != "All") {
      this.filteredSessions = this.filteredSessions?.filter(
        (nd) => nd.os == this.filterOs
      );
    }
    if (this.filterVms != "All") {
      this.filteredSessions = this.filteredSessions?.filter(
        (nd) => nd.vmName == this.filterVms
      );
    }
    if (this.filterUser != "All") {
      this.filteredSessions = this.filteredSessions?.filter(
        (nd) => nd.user == this.filterUser
      );
    }
    if (
      this.filterSessionState != "All" &&
      this.filterSessionState != "ReadyRequested"
    ) {
      this.filteredSessions = this.filteredSessions?.filter(
        (nd) => nd.state.substring(3) == this.filterSessionState
      );
    }
    if (this.filterSessionState == "ReadyRequested") {
      this.filteredSessions = this.filteredSessions?.filter(
        (nd) =>
          nd.state.substring(3) == "Ready" ||
          nd.state.substring(3) == "Requested"
      );
    }
    if (this.sortApplied) {
      /* if (this.serialNoSort) { this.filteredSessions.sort((a, b) => 0 - (b.name.toLowerCase() < a.name.toLowerCase() ? -1 : 1)); }
       if (this.loginTimeSort) { this.filteredSessions.sort((a, b) => new Date(a.loginTime).getTime() - new Date(b.loginTime).getTime()) }
       if (this.idleTimeSort) { this.filteredSessions.sort((a, b) => new Date(b.idleTime).getTime() - new Date(a.idleTime).getTime()) }
       if (this.userSort) { this.filteredSessions.sort((a, b) => 0 - (b.user.toLowerCase() < a.user.toLowerCase() ? -1 : 1)) }
       if (this.nameSessionSort) { this.filteredSessions.sort((a, b) => 0 - (b.name.toLowerCase() < a.name.toLowerCase() ? -1 : -1)); } */
      this.applySort(this.sortBy);
    }
    return this.filteredSessions;
  }

  resetFilter() {
    //this.dataReloadSubscription?.unsubscribe()
    this.filterSessionState = "All";
    this.filterUser = "All";
    this.filterVms = "All";
    this.filterText = "";
    this.filterOs = "All";
    this.filterDeployment = "All";
    this.nameSessionSort = false;
    this.serialNoSort = false;
    this.loginTimeSort = false;
    this.idleTimeSort = false;
    this.userSort = false;
    this.sortApplied = false;
    this.loadSessionData();
  }

  startDataReloadSub() {
    this.dataReloadSubscription = interval(1000000000).subscribe(async () => {
      await this.loadSessionData();
    });
  }

  connectSession(session: Session) {
    this.dialog
      .open(ConfirmDialogComponent, {
        autoFocus: false,
        disableClose: false,
        width: "25%",
        data: {
          titleMessage: "Connect Session",
          bodyMessage: `Do you want to connect ${session.user} from ${session.vmName}`,
          cancelText: "Cancel",
          submitText: "Connect",
        },
      })
      .afterClosed()
      .subscribe((res) => {
        if (res) {
          this.spinner.show();
          this.snackBar.open("Action is in progress.", "Ok", {
            duration: 5000,
          });
          this.sessionService
            .connectSession(session.vmName, session.user, session.deployment)
            .pipe(take(1))
            .subscribe((data: any) => {
              if (data) {
                let response = JSON.parse(data["message"]);
                if (data.actionCode != ErrorCodes.Succeeded) {
                  this.snackBar.open(response.FileContent, "Ok", {
                    duration: 5000,
                  });
                  return;
                }

                if (response.VmPlatform.toLowerCase() == "windows") {
                  this.download(response.VmName + ".rdp", response.FileContent);
                } else if (
                  response.VmPlatform.toLowerCase() == "linux" &&
                  response.UseVncFileOnConnect
                ) {
                  this.download(response.VmName + ".vnc", response.FileContent);
                } else {
                  let url = response.FileContent;
                  window.open(url, "_blank", "noopener");
                  //this.download("", response.FileContent);
                }
                this.spinner.hide();
                this.refreshComponent();
              } else {
                this.snackBar.open("Something went wrong!", "Ok", {
                  duration: 5000,
                });
                this.spinner.hide();
                this.refreshComponent();
              }
            });
        }
      });
  }

  download(filename: string, fileData) {
    let url;
    if (filename) {
      filename = filename.replace(/['"]+/g, "");
      const blob = new Blob([fileData], { type: "text/csv" });
      url = window.URL.createObjectURL(blob);
    } else {
      url = fileData;
    }
    let elementAnchor = document.createElement("a");
    document.body.appendChild(elementAnchor);
    elementAnchor.setAttribute("style", "display: none");
    elementAnchor.href = url;
    elementAnchor.download = filename;
    elementAnchor.click();
    window.URL.revokeObjectURL(url);
    elementAnchor.remove();
  }

  permissionToConnect(session) {
    if (session.user.toLowerCase() === this.currentLoggedInUser.toLowerCase()) {
      return true;
    } else {
      return false;
    }
  }

  extendSessionTime(session: Session, extendPeriod: string) {
    if (session) {
      if (session.user.toLowerCase() != this.currentLoggedInUser) {
        this.snackBar.open("You don't have permission for this action.", "Ok", {
          duration: 5000,
        });
        return;
      }
      if (session.expirationTime == null) {
        this.snackBar.open("Your Session does not have a time limit.", "Ok", {
          duration: 5000,
        });
        return;
      }
      this.dialog
        .open(ConfirmDialogComponent, {
          autoFocus: false,
          disableClose: false,
          width: "25%",
          data: {
            titleMessage: "Extend Session",
            bodyMessage: `Do you want to extend ${session.name} time by ${extendPeriod} Hr`,
            cancelText: "Cancel",
            submitText: "Proceed",
          },
        })
        .afterClosed()
        .subscribe((res) => {
          if (res) {
            let wsName = session.vmName;
            this.sessionService
              .extendSession(null, session.user, wsName, extendPeriod)
              .subscribe((data) => {
                let res = JSON.parse(JSON.stringify(data));
                if (res.status == 200) {
                  this.snackBar.open(res.actionMessage, "Ok", {
                    duration: 5000,
                  });
                } else {
                  this.snackBar.open(res.actionMessage, "Ok", {
                    duration: 5000,
                  });
                }
              });
          } else {
            return;
          }
        });
    }
  }

  sortSessionName() {
    this.nameSessionSort = !this.nameSessionSort;
    this.serialNoSort = false;
    this.loginTimeSort = false;
    this.idleTimeSort = false;
    this.userSort = false;
    this.sortApplied = true;
    this.sortBy = "name";
    if (this.nameSessionSort) {
      this.filteredSessions.sort(
        (a, b) => 0 - (b.name.toLowerCase() < a.name.toLowerCase() ? -1 : 1)
      );
    } else {
      this.filteredSessions.sort(
        (a, b) => 0 - (b.name.toLowerCase() < a.name.toLowerCase() ? 1 : -1)
      );
    }
  }

  sortSessionState() {
    this.serialNoSort = !this.serialNoSort;
    this.loginTimeSort = false;
    this.idleTimeSort = false;
    this.userSort = false;
    this.nameSessionSort = false;
    this.sortApplied = true;
    this.sortBy = "state";
    if (this.serialNoSort) {
      this.filteredSessions.sort(
        (a, b) => 0 - (b.state.toLowerCase() < a.state.toLowerCase() ? -1 : 1)
      );
    } else {
      this.filteredSessions.sort(
        (a, b) => 0 - (b.state.toLowerCase() < a.state.toLowerCase() ? 1 : -1)
      );
    }
  }

  sortDate() {
    this.loginTimeSort = !this.loginTimeSort;
    this.serialNoSort = false;
    this.idleTimeSort = false;
    this.userSort = false;
    this.nameSessionSort = false;
    this.sortApplied = true;
    this.sortBy = "date";
    if (this.loginTimeSort) {
      this.filteredSessions.sort(
        (a, b) =>
          new Date(a.loginTime).getTime() - new Date(b.loginTime).getTime()
      );
    } else {
      this.filteredSessions.sort(
        (a, b) =>
          new Date(b.loginTime).getTime() - new Date(a.loginTime).getTime()
      );
    }
  }

  sortIdleTime() {
    this.idleTimeSort = !this.idleTimeSort;
    this.loginTimeSort = false;
    this.serialNoSort = false;
    this.userSort = false;
    this.nameSessionSort = false;
    this.sortApplied = true;
    this.sortBy = "idleTime";
    if (this.idleTimeSort) {
      this.filteredSessions.sort(
        (a, b) =>
          new Date(a.idleTime).getTime() - new Date(b.idleTime).getTime()
      );
    } else {
      this.filteredSessions.sort(
        (a, b) =>
          new Date(b.idleTime).getTime() - new Date(a.idleTime).getTime()
      );
    }
  }

  sortDuration() {
    this.durationSort = !this.durationSort;
    this.loginTimeSort = false;
    this.serialNoSort = false;
    this.userSort = false;
    this.nameSessionSort = false;
    this.sortApplied = true;
    this.sortBy = "duration";
    if (this.durationSort) {
      this.filteredSessions.sort(
        (a, b) =>
          new Date(a.duration).getTime() - new Date(b.duration).getTime()
      );
    } else {
      this.filteredSessions.sort(
        (a, b) =>
          new Date(b.duration).getTime() - new Date(a.duration).getTime()
      );
    }
  }

  sortUser() {
    this.userSort = !this.userSort;
    this.idleTimeSort = false;
    this.loginTimeSort = false;
    this.serialNoSort = false;
    this.nameSessionSort = false;
    this.sortApplied = true;
    this.sortBy = "user";
    if (this.userSort) {
      this.filteredSessions.sort(
        (a, b) => 0 - (b.user.toLowerCase() < a.user.toLowerCase() ? -1 : 1)
      );
    } else {
      this.filteredSessions.sort(
        (a, b) => 0 - (b.user.toLowerCase() < a.user.toLowerCase() ? 1 : -1)
      );
    }
  }

  applySort(entity: string) {
    if (entity == null) {
      return;
    }
    switch (entity) {
      case "user":
        if (this.userSort) {
          this.filteredSessions.sort(
            (a, b) => 0 - (b.user.toLowerCase() < a.user.toLowerCase() ? -1 : 1)
          );
        } else {
          this.filteredSessions.sort(
            (a, b) => 0 - (b.user.toLowerCase() < a.user.toLowerCase() ? 1 : -1)
          );
        }
        break;
      case "idleTime":
        if (this.idleTimeSort) {
          this.filteredSessions.sort(
            (a, b) =>
              new Date(a.idleTime).getTime() - new Date(b.idleTime).getTime()
          );
        } else {
          this.filteredSessions.sort(
            (a, b) =>
              new Date(b.idleTime).getTime() - new Date(a.idleTime).getTime()
          );
        }
        break;
      case "date":
        if (this.loginTimeSort) {
          this.filteredSessions.sort(
            (a, b) =>
              new Date(a.loginTime).getTime() - new Date(b.loginTime).getTime()
          );
        } else {
          this.filteredSessions.sort(
            (a, b) =>
              new Date(b.loginTime).getTime() - new Date(a.loginTime).getTime()
          );
        }
        break;
      case "state":
        if (this.serialNoSort) {
          this.filteredSessions.sort(
            (a, b) =>
              0 - (b.state.toLowerCase() < a.state.toLowerCase() ? -1 : 1)
          );
        } else {
          this.filteredSessions.sort(
            (a, b) =>
              0 - (b.state.toLowerCase() < a.state.toLowerCase() ? 1 : -1)
          );
        }
        break;
      case "name":
        if (this.nameSessionSort) {
          this.filteredSessions.sort(
            (a, b) => 0 - (b.name.toLowerCase() < a.name.toLowerCase() ? -1 : 1)
          );
        } else {
          this.filteredSessions.sort(
            (a, b) => 0 - (b.name.toLowerCase() < a.name.toLowerCase() ? 1 : -1)
          );
        }
        break;
      default:
        break;
    }
  }

  refreshComponent() {
    let url = this.router.url;
    this.router.navigateByUrl("/", { skipLocationChange: true }).then(() => {
      this.router.navigate([decodeURI(url)]);
    });
  }

  getToolTipForSession(session: Session) {
    this.sessionTooltipHtml = null;
    this.sessionTooltipHtml = session.nodeDescription;
    return this.sessionTooltipHtml;
  }

  getColumnSetting() {
    this.userService
      .getColumnSetting(this.currentLoggedInUser)
      .subscribe((res) => {
        if (res) {
          let s = JSON.parse(JSON.stringify(res));
          if (s.data != null) {
            let colInfo: UserSetting = <UserSetting>(
              JSON.parse(JSON.stringify(s.data))
            );
            colInfo.columnSetting.forEach((e) => {
              if (e.tableName == this.tableName) {
                this.editedColumnList = e.columnInfo.split(",");
                this.columnInfo = {
                  ...this.columnInfo,
                  coloumToShow: [...this.editedColumnList],
                };
              }
            });
          }
        }
      });
  }

  editColoum() {
    const editColumnDailog = this.dialog.open(EditColoumsComponent, {
      autoFocus: false,
      disableClose: true,
      width: "400px",
      data: {
        columnsFromComponents: [...this.columnInfo.columnsOfComponents],
        previoslySelectedColumns: [...this.columnInfo.coloumToShow],
      },
    });
    editColumnDailog.afterClosed().subscribe((res) => {
      if (res.status) {
        if (res.data != null && res.data.length >= 0) {
          let columsName = res.data.map((el) => el.name);
          let columsNameString = columsName.join(",");
          this.userService
            .updateUserColumnSetting(
              this.currentLoggedInUser,
              columsNameString,
              this.tableName
            )
            .subscribe((data) => {
              if (data) {
                let response = JSON.parse(JSON.stringify(data));
                if (response.status == 200) {
                  this.editedColumnList = columsNameString.split(",");
                  this.columnInfo = {
                    ...this.columnInfo,
                    coloumToShow: [...this.editedColumnList],
                  };
                  this.snackBar.open(response.actionMessage, "Ok", {
                    duration: 5000,
                  });
                } else if (response.status != 200) {
                  this.snackBar.open(response.actionMessage, "Ok", {
                    duration: 5000,
                  });
                }
              }
            });
        }
      }
    });
  }

  getSessionFromDeployment(depName: string) {
    let dep = depName;
    let reqObj = { platform: "any" };
    this.sessionService
      .requestSessionFromDeployment(
        dep,
        reqObj,
        "",
        this.currentLoggedInUser,
        this.timePeriod
      )
      //this._sessionService.connectSessionClient("gfgfgf", this.currentUser, this.dynamicWsForm.value.deploymentName)
      .subscribe((data: any) => {
        let response = JSON.parse(data["message"]);
        if (
          data.actionCode != ErrorCodes.Succeeded &&
          data.actionCode != ErrorCodes.In_Transition
        ) {
          this.snackBar.open(response.FileContent, "Ok", { duration: 5000 });
          this.spinner.hide("connectWs");
          return;
        }

        this.loadSessionData();
        setTimeout(() => {
          if (data.additionalInfo != null) {
            this.sessionService
              .checkSessionState(data.additionalInfo)
              .subscribe((data: any) => {
                if (data.state == "WTSReady") {
                  this.sessionService
                    .connectSessionClient(
                      response.VmName,
                      this.currentLoggedInUser,
                      depName,
                      null,
                      "0"
                    )
                    .subscribe((data: any) => {
                      if (data) {
                      }
                    });
                  this.loadSessionData();
                }
              });
          }
        }, 5000);
      });
  }

  loadClientSessionData() {
    this.sessionService
      //.getAllSessions().subscribe({
      .getClientSessionsForUser(this.currentLoggedInUser)
      .subscribe({
        next: (data) => {
          this.spinner.hide();
          if (data == null) {
            this.available = false;
            return;
          }
          this.clientSessions = <ClientSession[]>(
            JSON.parse(JSON.stringify(data))
          );
        },
        error: (err) => {
          this.spinner.hide();
          this.available = false;
        },
      });
    this.available = true;
  }

  checkDashboardRedirectSort() {
    this.redirectSortVal = this.sessionService.dashboardSessionRedirectSort;
    if (!this.redirectSortVal) return;
    if (this.redirectSortVal.toLowerCase() == "active") {
      this.filterSessionState = "Active";
      this.applyFilter();
    }
    if (this.redirectSortVal.toLowerCase() == "disconnected") {
      this.filterSessionState = "Disconnected";
      this.applyFilter();
    }
    if (this.redirectSortVal.toLowerCase() == "ready/requested") {
      this.filterSessionState = "ReadyRequested";
      this.applyFilter();
    }
    if (this.redirectSortVal.toLowerCase() == "windows") {
      this.filterOs = "WINDOWS";
      this.filterSessionState = "Active";
      this.applyFilter();
    }
    if (this.redirectSortVal.toLowerCase() == "linux") {
      this.filterOs = "LINUX";
      this.filterSessionState = "Active";
      this.applyFilter();
    }
    if (this.redirectSortVal.toLowerCase().indexOf("deployment") != -1) {
      let depAndRedirectVal = this.redirectSortVal?.split(",");
      this.filterDeployment = depAndRedirectVal[1];
      this.filterSessionState = "Active";
      this.applyFilter();
    }
    this.sessionService.dashboardSessionRedirectSort = null;
  }

  clearLocalStorage() {
    this.columnsLocalStorageNames.forEach((el) => localStorage.removeItem(el));
  }

  logOut() {
    this.clearLocalStorage();
    this.headerService.toRedirectSessions = true;
    this.headerService.toRedirectDeployments = true;
    this.headerService.updateDeploymentList(null);
    this.actionLogService.addActionLog(
      "SyncHPC",
      "SignOut",
      this.currentLoggedInUser,
      this.currentLoggedInUser,
      "User",
      "Sign Out"
    );
    this.authenticationService.logout();
    //this.router.navigate(['Login']);
  }
}
